module.exports = __webpack_public_path__ + "static/media/css-3.cc56234f.svg";